import moment from "moment";
import { Modal } from "./boxModal";
import { useEffect, useState } from "react";

function maskCNPJ(value = "") {
  const digits = value.replace(/\D/g, "").slice(0, 14);

  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

export function ManualReceiptModal({
  isOpen,
  onClose,
  data,
  onConfirm,
  photoModalClose
}) {
  const [form, setForm] = useState({
    issueDate: "",
    emitterCNPJ: "",
    emitterName: "",
    totalValue: "",
  });

  useEffect(() => {
    if (isOpen && data) {
      setForm({
        issueDate: data?.issueDate
          ? moment(data.issueDate).format("YYYY-MM-DD")
          : "",
        emitterCNPJ: data?.emitterCNPJ
          ? maskCNPJ(data.emitterCNPJ)
          : "",
        emitterName: data?.emitterName || "",
        totalValue: data?.totalValue || "",
      });
    }
  }, [isOpen, data]);

  function handleChange(e) {
    const { name, value } = e.target;

    if (name === "emitterCNPJ") {
      setForm((prev) => ({
        ...prev,
        emitterCNPJ: maskCNPJ(value),
      }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleSubmit() {
    const payload = {
      ...form,
      emitterCNPJ: form.emitterCNPJ.replace(/\D/g, ""),
    };

    onConfirm(payload);
    onClose();
    photoModalClose();
  }

  const isFormValid =
    form.issueDate.trim() !== "" &&
    form.emitterName.trim() !== "";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Preencher Informações Adicionais"
      showCancelButton
      onConfirm={handleSubmit}
      confirmDisabled={!isFormValid}
    >
      <div className="flex flex-col gap-4" style={{ color: "black" }}>
        <div>
          <label>Data de Emissão *</label>
          <input
            name="issueDate"
            value={form.issueDate}
            onChange={handleChange}
            className="border p-2 rounded w-full"
            type="date"
          />
        </div>

        <div>
          <label>CNPJ do Emissor</label>
          <input
            name="emitterCNPJ"
            value={form.emitterCNPJ}
            onChange={handleChange}
            className="border p-2 rounded w-full"
            placeholder="00.000.000/0000-00"
          />
        </div>

        <div>
          <label>Nome do Emissor *</label>
          <input
            name="emitterName"
            value={form.emitterName}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </div>

        <div>
          <label>Valor Total *</label>
          <input
            name="totalValue"
            value={form.totalValue}
            disabled
            className="border p-2 rounded w-full bg-gray-200 text-gray-700"
          />
        </div>
      </div>
    </Modal>
  );
}
